module.exports = __webpack_public_path__ + "img/msl_countdown.b5a4e5d6.png";